<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>
        <h2 class="titulo">ASSINATURA OBRIGATÓRIA</h2>
        <v-layout wrap class="justify-center">
            <v-flex xs12 md10>
                <div class="d-flex justify-center">
                    <h5 class="primary--text">A cota será alocada apenas após assinatura do contrato!</h5>
                </div>
                <div class="d-flex justify-center">
                    <v-row class="mt-2 mb-2">
                        <v-col cols="12" lg="4" class="order-lg-3"> </v-col>
                        <v-col cols="6" lg="4" class="order-lg-2 mx-auto" align-self="center">
                            <img v-if="pedido.bem.id_bem" :src="`${ws}/compra/imagembem/${pedido.bem.id_bem}`" alt=""
                                 style="flex: none !important; height: auto; width: 100%; object-fit: cover;" class="mt-2">
                        </v-col>
                        <v-col cols="12" lg="4" class="order-lg-1 mx-auto">
                            <IndicadorDecisaoCredito v-if="is_venda_reprovada || is_venda_aprovada" :is-reprovada="is_venda_reprovada" :is-aprovada="is_venda_aprovada" :motivo="pedido.motivo_decisao_credito" :id-pedido="pedido.id_pedido" />
                            <v-layout v-if="houve_pendencia">
                                <v-btn small class="transition mr-4 mt-4" color="primary" @click="abrirHistoricoPendencias()">
                                    Histórico de Pendências
                                </v-btn>
                            </v-layout>
                        </v-col>
                    </v-row>
                </div>
                <v-col class="d-flex justify-center mb-2" v-if="!isVendaNaoGerada(pedido.status_pedido) && exibe_contrato">
                    <div class="pt-2 align-center">
                        <v-icon class="align-self-center" color="primary">{{ getIconStatusContrato(pedido.contrato.status) }}</v-icon>
                        <label class="align-self-center" style="font-weight: bold;">Status do contrato: {{ getDescricaoStatusContrato(pedido.contrato.status,pedido.docusign_falha,pedido.docusign_enviado) }}</label>
                    </div>
                </v-col>
                <v-col v-if="pedido.contrato.status !== '' && exibe_contrato" class="d-flex align-center justify-center mb-4 flex-wrap">
                    <div v-if="pedido.contrato.status === StatusContrato.ContratoAssinado" class="btn-contratos mb-2 position-relative">
                        <v-menu offset-y v-model="dropdown_documentos_aberto">
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn color="primary" @click="visualizarDocumentos">
                                    Visualizar documentos
                                </v-btn>
                            </template>
                            <v-list>
                                <v-list-item v-for="(item, index) in documentos" :key="index" @click="visualizarDocumento(item)">
                                    <v-list-item-title>{{ item }}</v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </div>
                    <v-btn class="ml-5 mb-2" v-if="pedido.contrato.status === StatusContrato.ContratoPendente" color="secondary" @click="reenviarContrato">Reenviar contrato</v-btn>
                    <v-btn class="ml-5 mb-2" color="secondary" @click="getHistoricoReenvio">Histórico reenvios</v-btn>
                    <v-btn class="ml-5 mb-2" v-if="pedido.contrato.status === StatusContrato.ContratoAssinado" color="primary" @click="compartilharDocumentos">Compartilhar documentos</v-btn>
                </v-col>
                <div class="mx-1 mt-3 mb-5">
                    <DadosDaCompra :has-error="hasError" :pedido="pedido" :desconto="desconto" :permite-flavor-todos-produtos="!!permite_flavor_todos_produtos" :administradora="administradora" :seguro="seguro" :aguardando-pagamento-cliente="AguardandoPagamentoCliente" />
                </div>
                <div class="mx-1 mt-3 mb-5">
                    <v-layout wrap row-padding v-if="exibirBotoesBoleto()">
                        <v-flex col-12 col-md-6>
                            <v-btn v-if="exibe_reenvio_email" id="ButtonEmailChanges" block color="primary" @click="showChangedEmailHistory()" @close="closeChangedEmailHistory">
                                HISTÓRICO DE AJUSTES DO E-MAIL
                            </v-btn>
                        </v-flex>
                        <v-flex col-12 col-md-6>
                            <v-btn id="ButtonVisualizarBoleto" block color="secondary" @click="verBoleto()">Visualizar boleto</v-btn>
                            <v-btn id="ButtonHistoricoBoleto" block color="secondary" @click="getHistoricoBoleto()" class="mt-3" v-if="pedido.historico_envio_boleto.length > 0">Histórico de Envio de Boletos</v-btn>
                        </v-flex>
                    </v-layout>
                    <v-row>
                        <v-flex col-12 col-md-6>
                            <v-btn id="ButtonReenviarCodigo" block class="mt-3" v-if="AguardandoPagamentoCliente" color="primary" @click="openDialogEmail()">
                                Reenviar email com código de pagamento
                            </v-btn>
                            <v-btn id="ButtonEmailChanges" class="mt-3" block color="primary" v-if="!exibirBotoesBoleto() && exibe_reenvio_email" @click="showChangedEmailHistory()" @close="closeChangedEmailHistory">
                                HISTÓRICO DE AJUSTES DO E-MAIL
                            </v-btn>
                        </v-flex>
                        <v-flex col-12 col-md-6>
                            <v-btn id="ButtonHistoricoLink" block color="secondary" @click="getHistoricoLink()" class="mt-3" v-if="AguardandoPagamentoCliente">
                                Histórico de Envio de Links
                            </v-btn>
                        </v-flex>
                    </v-row>
                </div>
                <div class="mb-5">
                    <v-row class="primary--text ma-1 pointer" @click="sections.cliente = !sections.cliente">
                        <h2>Dados do cliente</h2>
                        <v-spacer />
                        <v-icon color="primary" class="mt-1" :class="{ 'rotate90': sections.cliente }">
                            chevron_right
                        </v-icon>
                    </v-row>
                    <v-divider />
                    <collapse-transition>
                        <div class="ma-1 my-3" v-show="sections.cliente">
                            <v-layout wrap>
                                <v-flex xs12 md6>
                                    <label>{{ isPessoaFisica() ? 'CPF' : 'CNPJ' }}</label>
                                    <p>
                                        {{ (isPessoaFisica() ? pedido.cliente.cpf : pedido.cliente.cnpj) || '-' }}
                                    </p>
                                </v-flex>
                                <v-flex xs12 md6>
                                    <label>{{ isPessoaFisica() ? 'Nome' : 'Razão social' }}</label>
                                    <p>
                                        {{ cliente() }}
                                    </p>
                                </v-flex>
                                <v-flex xs12 md6 v-if="!isPessoaFisica()">
                                    <label>Nome fantasia</label>
                                    <p>
                                        {{ nomeFantasia() }}
                                    </p>
                                </v-flex>
                                <v-flex xs12 md6>
                                    <label>
                                        {{ isPessoaFisica() ? 'Data de nascimento' : 'Data de fundação' }}
                                    </label>
                                    <p>{{ getData(pedido) }}</p>
                                </v-flex>
                                <v-flex xs12 md6>
                                    <label>{{ isPessoaFisica() ? 'Nacionalidade' : 'Atividade' }}</label>
                                    <p>
                                        {{ nacionalidadeAtividade() }}
                                    </p>
                                </v-flex>
                                <v-flex xs12 md6 v-if="isPessoaFisica()">
                                    <label>{{ 'Sexo' }}</label>
                                    <p>
                                        {{ sexoNomeSocio() }}
                                    </p>
                                </v-flex>
                                <v-flex xs12 md6>
                                    <label>{{ isPessoaFisica() ? 'Renda' : 'Faturamento médio' }}</label>
                                    <p>{{ getMoney(pedido) }}</p>
                                </v-flex>
                                <v-flex xs12 md6 v-if="isPessoaFisica()">
                                    <label>Politicamente exposto</label>
                                    <p>{{ getPoliticamenteExposto() }}</p>
                                </v-flex>
                                <v-flex xs12 md6>
                                    <label>Telefone</label>
                                    <p>
                                        {{ getTelefone(pedido.cliente, pedido.instancia_cliente) }}
                                    </p>
                                </v-flex>
                                <v-flex xs12 md6>
                                    <label>Celular</label>
                                    <p>{{ getTelefoneCelular(pedido.instancia_cliente, pedido.cliente) }}</p>
                                </v-flex>
                                <v-flex xs12 md6>
                                    <label>E-mail</label>
                                    <p>{{ getEmail(pedido.instancia_cliente, pedido.cliente) }}</p>
                                    <v-tooltip bottom color="white" v-if="shouldDisableEditButton && exibe_reenvio_email">
                                        <template v-slot:activator="{ on, attrs }">
                                            <span v-bind="attrs" v-on="on">
                                                <v-btn :disabled="shouldDisableEditButton" class="mt-2" color="primary">
                                                    <v-icon size="18" class="pr-3" color="white">mdi-pencil</v-icon>
                                                    Editar e-mail
                                                </v-btn>
                                            </span>
                                        </template>
                                        <div v-if="shouldDisableEditButton" style="color:#222">
                                            Impossível editar o e-mail para propostas alocadas, assinadas ou processando a criação do contrato
                                        </div>
                                    </v-tooltip>
                                    <v-btn v-else-if="exibe_reenvio_email" @click="showChangeEmailDialog" class="mt-2" color="primary">
                                        <v-icon size="18" class="pr-3" color="white">mdi-pencil</v-icon>
                                        Editar e-mail
                                    </v-btn>
                                </v-flex>
                            </v-layout>
                        </div>
                    </collapse-transition>
                </div>
                <div class="mb-5" v-if="!isPessoaFisica()">
                    <v-row class="primary--text ma-1 pointer" @click="sections.socios = !sections.socios">
                        <h2>Dados do(s) Sócio(s)</h2>
                        <v-spacer />
                        <v-icon color="primary" class="mt-1" :class="{ 'rotate90': sections.socios }">
                            chevron_right
                        </v-icon>
                    </v-row>
                    <v-divider />
                    <collapse-transition>
                        <div class="ma-1 my-3" v-show="sections.socios">
                            <v-layout wrap>
                                <v-flex xs12 md6>
                                    <label>{{ 'Nome' }}</label>
                                    <p>
                                        {{ pedido.cliente_pedido.nome_completo }}
                                    </p>
                                </v-flex>
                                <v-flex xs12 md6>
                                    <label>{{ 'CPF' }}</label>
                                    <p>
                                        {{ pedido.cliente_pedido.cpf || '-' }}
                                    </p>
                                </v-flex>
                                <v-flex xs12 md6>
                                    <label>Politicamente exposto</label>
                                    <p>{{ getPoliticamenteExposto() }}</p>
                                </v-flex>
                                <v-flex xs12 md6>
                                    <label>Beneficiário Final</label>
                                    <p>{{ pedido.beneficiario.cpf == pedido.cliente.cpf_socio ? 'Sim' : 'Não' }}</p>
                                </v-flex>
                                <v-flex xs12 md6 v-if="pedido.beneficiario.cpf !== pedido.cliente.cpf_socio">
                                    <label>Nome do beneficiario</label>
                                    <p>{{ pedido.beneficiario.nome_completo ? pedido.beneficiario.nome_completo : pedido.cliente.nome_completo || '-' }}</p>
                                </v-flex>
                                <v-flex xs12 md6 v-if="pedido.beneficiario.cpf !== pedido.cliente.cpf_socio">
                                    <label>CPF do beneficiario</label>
                                    <p>{{ pedido.beneficiario.cpf ? pedido.beneficiario.cpf : pedido.cliente.cpf_socio || '-' }}</p>
                                </v-flex>
                                <v-flex xs12 md6 v-if="pedido.beneficiario.cpf !== pedido.cliente.cpf_socio">
                                    <label>Politicamente exposto?</label>
                                    <p>{{ getBeneficiarioPoliticamenteExposto() ? getBeneficiarioPoliticamenteExposto() : getPoliticamenteExposto() || '-' }}</p>
                                </v-flex>
                            </v-layout>
                        </div>
                    </collapse-transition>
                </div>
                <div class="mb-5">
                    <v-row class="primary--text ma-1 pointer" @click="sections.endereco = !sections.endereco">
                        <h2>Endereço</h2>
                        <v-spacer />
                        <v-icon color="primary" class="mt-1" :class="{ 'rotate90': sections.endereco }">
                            chevron_right
                        </v-icon>
                    </v-row>
                    <v-divider />
                    <collapse-transition>
                        <div class="ma-1 my-3" v-show="sections.endereco">
                            <v-layout wrap>
                                <v-flex xs12 md6>
                                    <label>CEP</label>
                                    <p>{{ enderecos[0] ? getCep(enderecos[0]) : '-' }}</p>
                                </v-flex>
                                <v-flex xs12 md6>
                                    <label>Nome do logradouro</label>
                                    <p>{{ enderecos[0].endereco || '-' }}</p>
                                </v-flex>
                                <v-flex xs12 md6>
                                    <label>Número</label>
                                    <p>{{ enderecos[0].numero || '-' }}</p>
                                </v-flex>
                                <v-flex xs12 md6>
                                    <label>Complemento</label>
                                    <p>{{ enderecos[0].complemento || '-' }}</p>
                                </v-flex>
                                <v-flex xs12 md6>
                                    <label>Bairro</label>
                                    <p>{{ enderecos[0].bairro || '-' }}</p>
                                </v-flex>
                                <v-flex xs12 md6>
                                    <label>Cidade / Estado</label>
                                    <p>{{ enderecos[0].cidade.nome || '' }} - {{ enderecos[0].cidade.uf || '' }}</p>
                                </v-flex>
                            </v-layout>
                        </div>
                    </collapse-transition>
                </div>
                <v-layout row-padding class="justify-space-between">
                    <v-flex class="col">
                        <v-btn id="ButtonVoltar" block color="secondary" @click="voltar()" style="margin-left: 0;">Voltar</v-btn>
                    </v-flex>
                </v-layout>
            </v-flex>
        </v-layout>

        <DialogChangeEmailHistory v-model="show_email_changed_history" @close="closeChangedEmailHistory" :id-pedido="pedido.id_pedido" />

        <DialogHistoryReasonAutorization v-model="showHistoryAuth" :historico="historico_motivo" :title="'HISTÓRICO DE PENDÊNCIAS'" />

        <DialogChangeEmail v-model="dialog_change_email" @change_email_outside="changeEmail" :old-email="(pedido.instancia_cliente && pedido.instancia_cliente.email) || (pedido.cliente && pedido.cliente.email) || ''" :pedido="pedido" @close="closeChangeEmailDialog" />

        <DialogConfirmarEmail v-model="dialog_email"
                              :email="(pedido.cliente && pedido.cliente.email) || ''"
                              @enviar="atualizarEmail" />

        <DialogHistorico v-model="show_historico_boleto"
                         tipo-historico="boleto"
                         :historico="pedido.historico_envio_boleto" />

        <DialogHistorico v-model="show_historico_link"
                         tipo-historico="link"
                         :historico="pedido.historico_envio_link" />

        <DialogHistorico
                v-model="show_historico_contrato"
                tipo-historico="contrato"
                :historico="historico_contrato" />
    </div>
</template>

<script>
  import { alert, trimZeros, notification, getNomeEmpresaPorIdEmpresa, isVendaNaoGerada, verifyIfPaidAndReturnInText, getDescricaoStatusContrato, unmask } from '@/plugins/helpers'
  import { FormasPagamento, OpcoesFuroDesc, PoliticamenteExposto, StatusContrato, StatusPedido, TipoPessoa, FormasPagamentoDesc } from '@/plugins/constants'
  import { getTextCodigoPagamento } from '@/plugins/textFormatters'
  import { cep, money, toDateBR } from '@/plugins/formatters'
  import { get } from 'lodash'
  import DialogChangeEmailHistory from '@/dialogs/DialogChangeEmailHistory'
  import DialogConfirmarEmail from '@/dialogs/DialogConfirmarEmail'
  import DialogChangeEmail from '@/dialogs/DialogChangeEmail'
  import DialogHistorico from '@/dialogs/DialogHistorico'
  import reenviarContratoMixin from '@/mixins/reenviarContratoMixin'
  import { mapState } from 'vuex'
  import detalhesAndResumo from '@/mixins/detalhesAndResumo'
  import creditAnalysis from '@/mixins/creditAnalysis'
  import IndicadorDecisaoCredito from '../../../components/analise-credito/IndicadorDecisaoCredito.vue'
  import { SituationAnalysisCredit } from '../../../plugins/constants'
  import { icones_status_hashmap } from '../../../plugins/listaStatusStyles'
  import { pedido_default } from '../../../plugins/pedido_default'
  import { AlertTypes } from '../../../plugins/alerts_types'
  import DadosDaCompra from '../../../fragments/InformacoesProposta/DadosDaCompra.vue'
  import telefonesMixin from '@/mixins/telefonesMixin'
  import emailMixin from '@/mixins/emailMixin'
  import DialogHistoryReasonAutorization from '@/views/painel/credit-analysis/consultation-reports-components/DialogHistoryReasonAutorization.vue'
  import { sendAnalyticsEvent } from '@/plugins/googleAnalytics'
  export default {
    name: 'ContratoAssinaturaAlocacao',
    components: { DialogHistorico, DialogConfirmarEmail, DialogChangeEmail, DialogChangeEmailHistory, IndicadorDecisaoCredito, DadosDaCompra, DialogHistoryReasonAutorization },
    mixins: [reenviarContratoMixin, detalhesAndResumo, creditAnalysis, telefonesMixin, emailMixin],
    props: { value: Object },
    data: () => ({
      is_quota_allocated: false,
      can_show_email_button: false,
      dialog_change_email: false,
      show_email_changed_history: false,
      exibe_reenvio_whatsapp: false,
      exibe_reenvio_email: false,
      documentos: [],
      administradora: '',
      permite_flavor_todos_produtos: false,
      desconto: false,
      historico_contrato: [],
      historico_motivo: [],
      houve_pendencia: false,
      showHistoryAuth: false,
      exibe_contrato: true,
      show_historico_boleto: false,
      show_historico_link: false,
      show_historico_contrato: false,
      hasError: false,
      sections: {
        cliente: true,
        endereco: true,
        socios: true
      },
      dialog_email: false,
      pedido: pedido_default,
      enderecos: [ {
        id_endereco: '',
        id_cliente: '',
        cep: '',
        endereco: '',
        numero: '',
        complemento: '',
        bairro: '',
        estado: '',
        id_cidade: '',
        principal: '',
        ativo: '',
        cidade: {
          nome: ''
        }
      } ]
    }),
    computed: {
      ...mapState(['permite_venda_todos_produtos']),
      OpcoesFuroDesc: () => OpcoesFuroDesc,
      StatusPedido: () => StatusPedido,
      StatusContrato: () => StatusContrato,
      TipoPessoa: () => TipoPessoa,
      FormasPagamentoDesc: () => FormasPagamentoDesc,
      shouldDisableEditButton () {
        return !(!this.is_quota_allocated && this.can_show_email_button &&
          (this.pedido.contrato.status === StatusContrato.ContratoPendente) &&
          (!isVendaNaoGerada(this.pedido.status_pedido) && this.pedido.status_pedido !== StatusPedido.Cancelado))
      },
      /**
       * @return {boolean}
       */
      AguardandoPagamentoCliente () {
        return this.pedido.forma_pagamento === FormasPagamento.Link && !isVendaNaoGerada(this.pedido.status_pedido) && this.pedido.status_pedido !== StatusPedido.Cancelado && this.pedido.status_pedido !== StatusPedido.Pago && this.pedido.status_pedido !== StatusPedido.CanceladoNewcon
      },
      seguro () {
        return this.$session.get('configuracoes').seguro
      },
      nome_comissionado () {
        const comissionados = this.$session.get('comissionados')
        const comissionado = comissionados.find(c => c.ID_Comissionado === this.pedido.id_comissionado)
        let nome_comissionado = ''
        if (comissionado) {
          nome_comissionado = `${comissionado['CD_Comissionado']} - ${comissionado['NM_Pessoa']}`
        }
        return nome_comissionado
      },
      dropdown_documentos_aberto: {
        get () {
          return this.documentos.length > 0
        },
        set (aberto) {
          if (!aberto) {
            this.documentos = []
          }
        }
      }
    },
    watch: {
      dropdown_documentos_aberto (aberto) {
        if (!aberto) {
          this.limparDocumentos()
        }
      }
    },
    async mounted () {
      this.permite_flavor_todos_produtos = this.$session.get('permite_venda_todos_produtos')
      this.exibe_contratos = this.$session.get('exibe_contratos_sistema')
      this.exibe_reenvio_whatsapp = this.$session.get('exibe_reenvio_whatsapp')
      this.exibe_reenvio_email = this.$session.get('exibe_reenvio_email')

      await this.getPedido()

      if (this.pedido.id_consulta) {
        await this.historicoPendencia(this.pedido.id_consulta)
      }
    },
    methods: {
      getDescricaoStatusContrato,
      verifyIfPaidAndReturnInText (status_pedido) {
        return verifyIfPaidAndReturnInText(status_pedido)
      },
      async getPedido () {
        if (this.value && this.value.id_pedido) {
          try {
            const res = await this.$http.get(`/vendas/${this.value.id_pedido}`)
            this.desconto = res.data.desconto
            res.data.beneficiario = { ...this.pedido.beneficiario, ...res.data.beneficiario }
            res.data.cliente_pedido = { ...this.pedido.cliente_pedido, ...res.data.cliente_pedido }
            res.data.cliente = { ...this.pedido.cliente, ...res.data.cliente }
            res.data.produto = { ...this.pedido.produto, ...res.data.produto }
            res.data.bem = { ...this.pedido.bem, ...res.data.bem }
            res.data.grupo = { ...this.pedido.grupo, ...res.data.grupo }
            res.data.plano = { ...this.pedido.plano, ...res.data.plano }
            this.pedido = { ...this.pedido, ...res.data }
            await this.getQuotaAllocationStatus()

            if (this.pedido.cliente.enderecos.length > 0) {
              this.enderecos = this.pedido.cliente.enderecos
            }

            if (this.pedido.status_pedido === StatusPedido.AguardandoDecisaoAnaliseCredito) {
              this.setVendaAnalise()
            } else if (this.pedido.status_pedido === StatusPedido.ReprovadoAnaliseCredito) {
              this.setVendaReprovada()
            } else if (this.pedido.status_pedido === StatusPedido.AprovadoAnaliseCredito) {
              this.setVendaAprovada()
            } else if (this.pedido.motivo_decisao_credito && this.pedido.analiseCredito.situacao === SituationAnalysisCredit.APROVADO) {
              this.setVendaAprovada()
            }

            if (res.data.id_empresa) { this.administradora = getNomeEmpresaPorIdEmpresa(res.data.id_empresa) }
          } catch (err) {
            this.hasError = true
            notification(AlertTypes.ERROR, err, 'Não foi possível buscar a venda.')
          }
        }
      },
      changeEmail (newEmail) {
        this.pedido.cliente.email = newEmail
        this.pedido.instancia_cliente.email = newEmail
      },
      isPessoaFisica () {
        return this.pedido.cliente.pessoa === TipoPessoa.Fisica
      },
      cliente () {
        return (this.isPessoaFisica() ? this.pedido.cliente.nome_completo : this.pedido.cliente_pedido.razao_social) || '-'
      },
      nacionalidadeAtividade () {
        return (this.isPessoaFisica() ? this.pedido.cliente.nacionalidade : this.pedido.cliente.atividade.nome) || '-'
      },
      sexoNomeSocio () {
        return (this.isPessoaFisica() ? _.startCase(this.pedido.cliente.genero) : '-')
      },
      isVendaNaoGerada (status_venda) {
        return isVendaNaoGerada(status_venda)
      },
      nomeFantasia () {
        return this.pedido.cliente_pedido.nome_fantasia
      },
      async getQuotaAllocationStatus () {
        try {
          await this.$http.get(`/proposta/allocation_status/${this.pedido.id_pedido}`).then((response) => {
            this.is_quota_allocated = response.data.is_quota_allocated
          })
        } catch (err) {
          this.is_quota_allocated = false
        }
        this.can_show_email_button = true
      },
      async historicoPendencia (id_consulta) {
        await this.$http
          .get(`/credit_analysis/history_reason/${id_consulta}`)
          .then(res => {
            this.historico_motivo = res.data
            this.houve_pendencia = res.data.some(
              motivo => motivo.situacao_antiga === SituationAnalysisCredit.PENDENCIA_CADASTRAL
            )
          })
          .catch(e => {
            notification('error', e, 'Não foi possível exibir os motivos.')
          })
      },
      abrirHistoricoPendencias () {
        sendAnalyticsEvent(this.$gtag, 'alterar_dados_pendentes', {
          id_pedido: this.pedido.id_pedido,
          hierarquia: this.$session.get('hierarquia_comercial'),
          valor_credito: this.pedido.analiseCredito.vl_credito,
          bem: this.pedido.bem.nome_bem,
          cliente: {
            cpf_cnpj: this.pedido.cliente.pessoa === TipoPessoa.Fisica ? unmask(this.pedido.cliente.cpf) : unmask(this.pedido.cliente.cnpj)
          }
        })
        this.showHistoryAuth = true
      },
      closeChangeEmailDialog () {
        this.dialog_change_email = false
      },
      closeChangedEmailHistory () {
        this.show_email_changed_history = false
      },
      showChangedEmailHistory () {
        this.show_email_changed_history = true
      },
      showChangeEmailDialog () {
        this.dialog_change_email = true
      },
      getData (pedido) {
        let data = pedido.cliente.pessoa === TipoPessoa.Fisica ? pedido.cliente.data_nascimento : pedido.cliente_pedido.data_fundacao
        if (data) {
          return toDateBR(data)
        }
        return '-'
      },
      getMoney (pedido) {
        let renda = pedido.cliente.pessoa === TipoPessoa.Fisica ? pedido.cliente.renda : pedido.cliente.faturamento_medio
        if (renda) {
          return money(renda)
        }
        return '-'
      },
      getCep (endereco) {
        const _cep = endereco.cep
        return _cep ? cep(_cep) : '-'
      },
      getPoliticamenteExposto () {
        if (this.pedido.cliente.politicamente_exposto) {
          return this.pedido.cliente.politicamente_exposto === PoliticamenteExposto.NaoPoliticamenteExposto ? 'Não' : 'Sim'
        }
        return '-'
      },
      getBeneficiarioPoliticamenteExposto () {
        if (this.pedido.beneficiario.politicamente_exposto) {
          return this.pedido.beneficiario.politicamente_exposto === PoliticamenteExposto.NaoPoliticamenteExposto ? 'Não' : 'Sim'
        }
        return '-'
      },
      gerarNovoBoleto () {
        alert({
          text: `Ao gerar um novo boleto, será registrado no DDA do cliente (caso o mesmo tenha aderido) essa nova cobrança, caso queira somente reenviar o boleto da venda, utilizar o botão “Visualizar Boleto”.`,
          buttons: {
            'Cancelar': () => true,
            'Confirmar': async () => this.openDialogEmail()
          }
        })
      },
      openDialogEmail () {
        this.dialog_email = true
      },
      getIconStatusContrato (status) {
        if (icones_status_hashmap[status]) {
          return icones_status_hashmap[status]
        }
        return 'work_off'
      },
      compartilharDocumentos () {
        alert({
          text: 'Deseja compartilhar todos os documentos do contrato via e-mail?',
          buttons: {
            'Nao': { text: 'Não' },
            'Sim': async () => {
              try {
                await this.$http.post(`/contrato/compartilhar/${this.pedido.contrato.id_contrato}`)
                notification('success', 'Contrato agendado para compartilhamento com sucesso!')
              } catch (e) {
                notification('error', e, 'Não foi possível compartilhar os documentos')
              }
            }
          }
        })
      },
      reenviarContrato () {
        this.showDialogReenviaContrato(this.pedido.contrato.id_contrato, this.pedido.whatsapp, this.exibe_reenvio_whatsapp)
      },
      async visualizarDocumentos () {
        try {
          const { data } = await this.$http.get(`/contrato/documentos/${this.pedido.contrato.hash_contrato}`)
          this.documentos = data
        } catch (e) {
          const status_code = get(e, 'response.status', 500)
          if (status_code === 404) {
            notification('error', 'Falha ao identificar documentos da proposta. Tente novamente mais tarde.')
          } else {
            notification('error', e, 'Não foi possível visualizar os documentos')
          }
        }
      },
      visualizarDocumento (documento) {
        window.open(`${this.ws}/contrato/baixar/${this.pedido.contrato.hash_contrato}/${documento}`)
      },
      limparDocumentos () {
        // Espero 500ms pra garantir que o usuário consiga baixar o documento antes de deletar ele
        setTimeout(async () => {
          this.$http.delete(`/contrato/documentos/${this.pedido.contrato.id_contrato}`)
          this.documentos = []
        }, 500)
      },
      async getHistoricoBoleto () {
        try {
          const { data } = await this.$http.get(`/vendas/${this.pedido.id_pedido}/historicoboleto`)
          this.pedido.historico_envio_boleto = data
          this.show_historico_boleto = true
        } catch (e) {
          notification('error', e, 'Não possível atualizar o histórico de envio de boletos ao cliente. É possível que você veja uma listagem defasada')
        }
      },
      async getHistoricoLink () {
        try {
          const { data } = await this.$http.get(`/vendas/${this.pedido.id_pedido}/historicolink`)
          this.pedido.historico_envio_link = data
          this.show_historico_link = true
        } catch (e) {
          notification('error', e, 'Não possível atualizar o histórico de envio de link ao cliente. É possível que você veja uma listagem defasada')
        }
      },

      async getHistoricoReenvio () {
        this.$http.get(`/contrato/historico_contrato/${this.pedido.id_pedido}`)
          .then(result => {
            this.historico_contrato = result.data
            this.show_historico_contrato = true
          })
          .catch(err => notification('error', err, 'Não foi possível buscar o contrato!'))
      },
      trimZeros,
      async voltar () {
        this.$emit('finalizado')
        this.$router.replace('minhas-vendas')
      },
      verBoleto () {
        window.open(`${this.ws}/boleto/${this.pedido.id_documento}`)
      },
      emitirBoleto () {
        this.$http.post('/proposta/boleto/enviar', {
          id_pedido: this.pedido.id_pedido,
          email: this.pedido.cliente.email,
          reenvio: true,
          vendedor: true
        })
          .then(() => {
            notification('success', 'Forma de pagamento enviada com sucesso! Em breve você receberá um e-mail com o boleto.')
          })
          .catch(err => {
            this.getHistoricoBoleto()
            notification('error', err, 'Não foi possível reemitir o boleto')
          })
      },
      exibirBotoesBoleto () {
        return this.pedido.forma_pagamento === FormasPagamento.Boleto
      },
      copiarLinkPagamento () {
        const el = document.createElement('textarea')
        el.value = this.pedido.link_pagamento
        document.body.appendChild(el)
        el.select()
        document.execCommand('copy')
        document.body.removeChild(el)
        notification('info', 'Link de pagamento copiado.')
      },
      toggleSeguro () {
        if (this.seguro.permite_editar) {
          if (!this.pedido.seguro) {
            alert({
              text: 'O Seguro Prestamista da direito ao sorteio mensal do Prêmio Pontualidade, que é uma recompensa em dinheiro que não tem vínculo com a cota, por isso, poderá utiliza-la da forma que desejar. Também é uma garantia de que a inadimplência poderá ser evitada, no caso de sinistro.',
              buttons: {
                'Desistir do seguro': () => true,
                'Aceitar o seguro': () => {
                  this.pedido.seguro = true
                }
              }
            })
          }
        } else {
          this.$nextTick(function () {
            this.pedido.seguro = this.seguro.valor_padrao
          })
        }
      },
      async atualizarEmail (email) {
        const { id_cliente, email: email_antigo } = this.pedido.cliente

        if (email_antigo !== email) {
          await this.$http.patch(`/clientes/${id_cliente}/email`, { email })

          this.pedido.cliente.email = email

          this.$emit('input', this.pedido)
        }

        if (this.pedido.forma_pagamento === FormasPagamento.Link) {
          this.reenviarEmail()
        } else {
          this.emitirBoleto()
        }
      },
      async reenviarEmail () {
        await this.$http.post('/proposta/linkpagamento/reenviar', { id_pedido: this.pedido.id_pedido })
        notification('success', 'Link de pagamento enviado com sucesso!')
      },
      getTextCodigoPagamento (formaPagamento, codigoPagamentoCliente, dataValidade) {
        return getTextCodigoPagamento(formaPagamento, codigoPagamentoCliente, dataValidade)
      }
    }
  }
</script>

<style lang="scss" scoped>
    label {
    font-size: 1rem;
    color: var(--darkgray);
}

p {
    color: var(--dark);
    font-size: 1.1rem;
}
</style>
